import { FormFieldTypes } from "../../../../data/formFieldType";

export const ApproveSGBPCategoryCriteriaData = {
  name: "AdditionalInfo",
  initialState: {
    searchByCriteriaName: null,
    channel: null,
    statusId: null,
    categoryId: null,
    subCategoryId: null,
    type: null,
  },
  formFields: [
    {
      id: "searchByCriteriaName",
      lable: "Search by Code",
      Field_Name: "Search by Code",
      fieldType: FormFieldTypes.SELECT,
      dataField: "searchByCriteriaName",
      fieldSetting: {
        placeholder: "",
        options: [],
        isSearchable: true
      },
      style: {
        containerCss: "col-lg-12 mb-3 pr-0",
      },
    },

    {
      id: "categoryId",
      lable: "Category",
      Field_Name: "Category",
      fieldType: FormFieldTypes.SELECT,
      dataField: "categoryId",
      fieldSetting: {
        placeholder: "Select",
        options: [],
      },
      style: {
        containerCss: "col-lg-4 mb-3",
      },
    },
    {
      id: "subCategoryId",
      lable: "Sub Category",
      Field_Name: "Sub Category",
      fieldType: FormFieldTypes.SELECT,
      dataField: "subCategoryId",
      fieldSetting: {
        placeholder: "Select",
        options: [],
      },
      style: {
        containerCss: "col-lg-4 mb-3",
      },
    },
    {
      id: "type",
      lable: "Type",
      Field_Name: "Type",
      fieldType: FormFieldTypes.SELECT,
      dataField: "type",
      fieldSetting: {
        placeholder: "Select",
        options: [],
      },
      style: {
        containerCss: "col-lg-4 mb-3",
      },
    },
    {
      id: "statusId",
      lable: "Status",
      Field_Name: "Status",
      fieldType: FormFieldTypes.SELECT,
      dataField: "statusId",
      fieldSetting: {
        placeholder: "Select",
        options: [],
      },
      style: {
        containerCss: "col-lg-4",
      },
    },
    {
      id: "channel",
      lable: "Channel",
      Field_Name: "Channel",
      fieldType: FormFieldTypes.SELECT,
      dataField: "channel",
      fieldSetting: {
        placeholder: "Select",
        options: [],
      },
      style: {
        containerCss: "col-lg-4",
      },
    },
  ],
  formSetting: {
    isViewOnly: false,
  },
};
